import styled, { css } from "styled-components";

import { safeElement } from "../../../utils";
import { responsiveArraySpreader } from "../../../utils";

export var SelectWrapper = styled.div.withConfig({
  displayName: "atoms__SelectWrapper",
  componentId: "mr023t-0"
})(["position:relative;width:100%;display:grid;grid-auto-flow:", ";", ""], function (props) {
  return props.direction === "vertical" ? "row" : "column";
}, function (props) {
  return responsiveArraySpreader(function (value) {
    return css(["grid-column-gap:", "rem;grid-row-gap:", "rem;"], value, value);
  }, props.gap);
});

export var FocusOverlay = styled.div.withConfig({
  displayName: "atoms__FocusOverlay",
  componentId: "mr023t-1"
})(["position:absolute;top:0;left:0;bottom:0;right:0;border-radius:inherit;z-index:-1;"]);

export var SelectRadioButton = styled(safeElement()).withConfig({
  displayName: "atoms__SelectRadioButton",
  componentId: "mr023t-2"
})(["opacity:0;position:fixed;width:0;&:focus + ", "{box-shadow:0px 0px 0px 6px ", ";}"], FocusOverlay, function (props) {
  return props.theme.formFocusColor;
});

export var SelectContainer = styled(safeElement()).withConfig({
  displayName: "atoms__SelectContainer",
  componentId: "mr023t-3"
})(["text-align:", ";box-sizing:border-box;cursor:pointer;font-family:inherit;padding:1rem;background-color:transparent;border-style:solid;border-color:", ";border-radius:", ";position:relative;width:100%;", ";"], function (props) {
  return props.center ? 'center' : 'left';
}, function (props) {
  return props.selected ? props.theme.primary : props.theme.formBorderColor;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.buttonDefaultHeight;
}, function (props) {
  return props.direction !== "vertical" && !props.gap ? css(["border-width:", "px;border-top-width:2px;border-bottom-width:2px;&:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px;border-left-width:2px;}&:last-child{border-top-right-radius:4px;border-bottom-right-radius:4px;border-right-width:2px;}"], props.selected ? 2 : 1) : props.direction === "vertical" && !props.gap ? css(["border-width:", "px;border-left-width:2px;border-right-width:2px;&:first-child{border-top-left-radius:4px;border-top-right-radius:4px;border-top-width:2px;}&:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom-width:2px;}"], props.selected ? 2 : 1) : css(["border-radius:4px;border-width:2px;"]);
});